import { render, staticRenderFns } from "./DocumentsLmListV1.vue?vue&type=template&id=094dc49d&scoped=true"
import script from "./DocumentsLmListV1.vue?vue&type=script&lang=js"
export * from "./DocumentsLmListV1.vue?vue&type=script&lang=js"
import style0 from "./DocumentsLmListV1.vue?vue&type=style&index=0&id=094dc49d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094dc49d",
  null
  
)

export default component.exports